(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["et-vendor-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (!root || root.hasAttribute('data-vvs-init')) return;
    root.setAttribute('data-vvs-init', '');

    var viewport = root.querySelector('[data-vvs-viewport]');
    var track    = root.querySelector('[data-vvs-track]');
    var dotsWrap = root.querySelector('[data-vvs-dots]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.et-vvs__slide'));

    /* ---------- Video playback (single-playback, play/pause) ---------- */
    function allVideos() { return root.querySelectorAll('video[data-vvs-el="video"]'); }

    function pauseAll(except) {
      allVideos().forEach(function (v) {
        if (v !== except) {
          v.pause();
          var m = v.closest('[data-vvs-media]');
          if (m) m.classList.remove('is-playing');
        }
      });
    }

    root.querySelectorAll('[data-vvs-media]').forEach(function (media) {
      var kind = media.getAttribute('data-kind');

      if (kind === 'file') {
        var video = media.querySelector('video');
        var playBtn = media.querySelector('.et-vvs__btn--play');
        var pauseBtn = media.querySelector('.et-vvs__btn--pause');
        if (!video) return;

        function play() {
          pauseAll(video);
          var p = video.play();
          if (p && p.catch) { p.catch(function () {}); }
          media.classList.add('is-playing');
        }
        function pause() { video.pause(); media.classList.remove('is-playing'); }

        if (playBtn) playBtn.addEventListener('click', function (e) { e.preventDefault(); play(); });
        if (pauseBtn) pauseBtn.addEventListener('click', function (e) { e.preventDefault(); pause(); });
        video.addEventListener('pause', function () { media.classList.remove('is-playing'); });
        video.addEventListener('play',  function () { media.classList.add('is-playing'); });

      } else if (kind === 'embed') {
        var btn = media.querySelector('.et-vvs__btn--play');
        var src = media.getAttribute('data-embed');
        if (!btn || !src) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          pauseAll(null);
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', src);
          iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('loading', 'lazy');
          media.classList.add('is-playing');
          media.appendChild(iframe);
          var poster = media.querySelector('.et-vvs__poster');
          if (poster) poster.style.display = 'none';
        }, { once: true });
      }
    });

    /* ---------- Pagination dots ---------- */
    var perPage = 1, pages = 1;

    function measure() {
      if (slides.length < 1) { perPage = 1; pages = 1; return; }
      var stride = slides.length > 1
        ? Math.abs(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left)
        : slides[0].getBoundingClientRect().width;
      if (!stride) stride = slides[0].getBoundingClientRect().width || 1;
      perPage = Math.max(1, Math.round(viewport.clientWidth / stride));
      pages = Math.max(1, Math.ceil(slides.length / perPage));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'et-vvs__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { scrollToPage(idx); });
        })(i);
        dotsWrap.appendChild(dot);
      }
      updateActive();
    }

    function scrollToPage(page) {
      var idx = Math.min(page * perPage, slides.length - 1);
      var target = slides[idx];
      if (!target) return;
      var delta = target.getBoundingClientRect().left - viewport.getBoundingClientRect().left;
      viewport.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function currentPage() {
      var vpLeft = viewport.getBoundingClientRect().left;
      var nearest = 0, min = Infinity;
      for (var p = 0; p < pages; p++) {
        var idx = Math.min(p * perPage, slides.length - 1);
        var d = Math.abs(slides[idx].getBoundingClientRect().left - vpLeft);
        if (d < min) { min = d; nearest = p; }
      }
      return nearest;
    }

    function updateActive() {
      if (!dotsWrap) return;
      var active = currentPage();
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === active);
        dots[i].setAttribute('aria-selected', i === active ? 'true' : 'false');
      }
    }

    var raf = null;
    viewport.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateActive(); });
    }, { passive: true });

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); buildDots(); }, 150);
    });

    measure();
    buildDots();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vvs]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
